// ChartViewContext.js
import React, { createContext, useState, useContext } from 'react';

const ChartViewContext = createContext();

export const ChartViewProvider = ({ children }) => {
  // Change default from "timeseries" to "results"
  const [selectedChartView, setSelectedChartView] = useState("results");
  return (
    <ChartViewContext.Provider value={{ selectedChartView, setSelectedChartView }}>
      {children}
    </ChartViewContext.Provider>
  );
};

export const useChartView = () => useContext(ChartViewContext);
